<div [class]="class">
  <label [attr.for]="for" [class]="labelClass">
    {{ label! | translate }}<i *ngIf="labelIcon" [class]="labelIcon + ' ms-1'"></i>
    <span class="theme-color ms-2 required-dot" *ngIf="required">*</span>
    <i *ngIf="tooltip" class="ri-information-line ms-1 text-muted cursor-pointer"
      [ngbTooltip]="tooltip | translate" placement="top" container="body"
      [popperOptions]="tooltipPopperOptions"
      [attr.aria-label]="tooltip | translate"></i>
  </label>
  <div [class]="gridClass">
    <ng-content></ng-content>
  </div>
</div>
